import React from 'react';
import { Text, Tooltip } from 'wix-style-react';
import { HeaderLine } from './HeaderLine';
import s from './TaxColumn.scss';
export var getTaxColumn = function (_a) {
    var t = _a.t;
    return {
        header: (React.createElement(HeaderLine, { dataHook: "tax-title" }, t('invoice-view:price-quote.view.line-items.tax'))),
        value: function (item, index) { return (React.createElement(React.Fragment, null, item.taxes.map(function (tax, taxIndex) {
            var _a;
            return (React.createElement("div", null,
                React.createElement(Text, { key: taxIndex, dataHook: "tax-".concat(index, "-").concat(taxIndex), className: s.taxItem, size: "small", weight: "normal" },
                    React.createElement("span", { style: {
                            minWidth: 0,
                            flex: '0 1 auto',
                        } },
                        React.createElement(Tooltip, { content: tax.name, size: "small", className: s.ellipsis }, tax.name)),
                    "\u00A0",
                    React.createElement("span", { style: { flex: '0 0 auto' } },
                        "(",
                        t('invoice-view:price-quote.view.totals.tax-rate-percent', {
                            rate: (_a = tax.rate.serializedValue) !== null && _a !== void 0 ? _a : 0,
                        }),
                        ")"))));
        }))); },
        width: '109px',
    };
};
//# sourceMappingURL=TaxColumn.js.map